<script setup>
import { onMounted, ref, nextTick } from 'vue'
import { useUserStore } from '@/stores/userStore'
import {formatToLocalTime} from '@/utils/index'
import { useI18n } from 'vue-i18n'
const userStore = useUserStore()
const props = defineProps(['list', 'model']);
const emits = defineEmits(['cancel'])
const { t } = useI18n();
const isMobile = ref(false)
const openModel=ref(false)
const list=ref(false)
const ipTime=userStore.ipTime;
onMounted(async () => {
    // npm install vue-meta@3.0.0-alpha.7
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    openModel.value=props.model
    list.value=props.list
    console.log(list.value)
});
const dialogVisible = () => {

    emits('cancel', false)
}
</script>
<template>
    <div>
        <div v-if="isMobile == false">
            <el-dialog v-model="openModel" :title="t('setup586')" width="700"  :before-close="dialogVisible"
                > 
                <div v-if="list?.length==0">
                    <el-empty :description="t('setup11')" />
                </div>
                <div v-else class="vertical-menu" style="height: 500px; 
    overflow-y: auto;">
                    <div class="menu-item"  v-for="(item,index) in list" :key="index">
                       <div class="time"><div class="Circle"></div>{{ formatToLocalTime(ipTime,item.track_time*1000 )}} </div> 
                       <div class="content">
                            <div> {{item.address}}</div>
                            <div>{{item.description }}</div>
                       </div>
                       
                    </div>
                </div>
            </el-dialog>
        </div>
        <div v-else>
            <el-drawer v-model="openModel" :title="t('setup586')" class="phone" show-close :with-header="true" direction="btt"
                :before-close="dialogVisible" size="80%">
           
                <div v-if="list?.length==0">
                    <el-empty :description="t('setup11')" />
                </div>
                <div class="vertical-menu" v-else>
                    <div class="menu-item"  v-for="(item,index) in list" :key="index">
                       <div class="time"><div class="Circle"></div>{{ formatToLocalTime(ipTime,item.track_time*1000 )}} </div> 
                       <div class="content">
                            <div> {{item.address}}</div>
                            <div>{{item.description }}</div>
                       </div>
                       
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>
<style scoped lang="scss">
.vertical-menu {
    display: flex;
    flex-direction: column;
    // align-items: center;
    // height: 100vh; /* 使容器占满整个视口高度 */
}
// last-child最后一个
.vertical-menu div:first-child {//第一个
    .time{
        color: #ff5722;
        .Circle{
            background-color: #ff5722; /* 橙色背景 */
            border-color: #ff5722; /* 橙色边框 */
        }
    }
   
   
}

.menu-item {
    
   
    .time{
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #0f1116;
        .Circle{
            width: 10px;
            height: 10px;
            border-radius: 50%;
            border: 2px solid #ccc; /* 灰色边框 */
            margin: 10px 0; /* 上下间距 */
            cursor: pointer;
            transition: background-color 0.3s; /* 背景颜色变化的过渡效果 */
            margin-right: 10px;
            
        }
    }
    .content{
        border-left: 1px dashed #c5c5c5;
        padding: 5px 5px 5px 10px;
        margin-left: 4px;
    }
}

// .menu-item:hover {
//     background-color: #eee; /* 鼠标悬停时的背景颜色 */
// }

// .active {
//     background-color: #ff5722; /* 橙色背景 */
//     border-color: #ff5722; /* 橙色边框 */
// }
</style>